import mercury from './planet-mercury.svg';
import mercuryInternal from './planet-mercury-internal.svg';
import mercuryGeology from './geology-mercury.png';
import venus from './planet-venus.svg';
import venusInternal from './planet-venus-internal.svg';
import venusGeology from './geology-venus.png';
import earth from './planet-earth.svg';
import earthInternal from './planet-earth-internal.svg';
import earthGeology from './geology-earth.png';
import mars from './planet-mars.svg';
import marsInternal from './planet-mars-internal.svg';
import marsGeology from './geology-mars.png';
import jupiter from './planet-jupiter.svg';
import jupiterInternal from './planet-jupiter-internal.svg';
import jupiterGeology from './geology-jupiter.png';
import saturn from './planet-saturn.svg';
import saturnInternal from './planet-saturn-internal.svg';
import saturnGeology from './geology-saturn.png';
import uranus from './planet-uranus.svg';
import uranusInternal from './planet-uranus-internal.svg';
import uranusGeology from './geology-uranus.png';
import neptune from './planet-neptune.svg';
import neptuneInternal from './planet-neptune-internal.svg';
import neptuneGeology from './geology-neptune.png';
import sourceIcon from './icon-source.svg';

export const photos = {
  mercury,
  mercuryInternal,
  mercuryGeology,
  venus,
  venusInternal,
  venusGeology,
  earth,
  earthInternal,
  earthGeology,
  mars,
  marsInternal,
  marsGeology,
  jupiter,
  jupiterInternal,
  jupiterGeology,
  saturn,
  saturnInternal,
  saturnGeology,
  uranus,
  uranusInternal,
  uranusGeology,
  neptune,
  neptuneInternal,
  neptuneGeology,
  sourceIcon,
};
